export const EMPTY_FILTERS = { basic: [], fields: [] };

export const CHAT_FILTERS_SLUGS = {
  tags: 'chatTagsFilter',
  branches: 'chatBranchesFilter',
  statuses: 'chatStatusesFilter',
  archived: 'chatArchivedFilter'
};

export const HELP_DESK_FILTERS_SLUGS = {
  BRANCHES: 'branches',
  CATEGORIES: 'helpDeskCategories',
  ASSIGNEES: 'helpDeskAssignees',
  PRIORITY: 'helpDeskPriority'
};

export const PROJECT_POST_FILTERS_SLUGS = {
  positions: 'projectPostPositions',
  locations: 'projectPostLocations',
  dates: 'projectPostDates',
  audience: 'projectPostAudience'
};

export const PROJECT_POST_FILTERS_ENUM = {
  dates: 1,
  locations: 2,
  positions: 3,
  audience: 4
};

export const SCHEDULING_BOARD_FILTERS_KEY = 'scheduling-board';

export const PROJECT_SCHEDULING_FILTERS_SLUGS = {
  positions: 'projectSchedulingPositions',
  locations: 'projectSchedulingLocations',
  mainLocations: 'projectSchedulingMainLocations',
  areas: 'projectSchedulingAreas',
  startTime: 'projectSchedulingStartTime',
  endTime: 'projectSchedulingEndTime',
  bookingStatus: 'projectSchedulingBookingStatus',
  bookingIssues: 'projectSchedulingBookingIssues',
  suppliers: 'projectSchedulingSuppliers',
  branchCostCenters: 'projectSchedulingBranchCostCenters',
  ageWarning: 'projectSchedulingAgeWarning',
  liveViewStatus: 'projectSchedulingLiveViewStatus'
};

// Options are passed in by the hiring page as externalOptions
export const HIRING_FILTERS_SLUGS = {
  BRANCHES: 'hiringBranches',
  POSITIONS: 'hiringPositions',
  STATUS: 'hiringStatus'
};

// `closed` is omitted: it has no source yet
export const HIRING_STATUS_FILTER_VALUES = {
  OPEN: 'open',
  PAUSED: 'paused',
  COMPLETED: 'completed',
  ARCHIVED: 'archived'
};

export const LIVE_VIEW_FILTERS_SLUGS = {
  costCenter: 'liveViewCostCenter',
  positions: 'liveViewPositions',
  locations: 'liveViewLocations',
  areas: 'liveViewAreas',
  clients: 'liveViewClients',
  startTime: 'liveViewStartTime',
  endTime: 'liveViewEndTime',
  eventBooker: 'liveViewEventBooker',
  employeeType: 'liveViewEmployeeType'
};

export const POSITIONS_SETTINGS_FILTERS_SLUGS = {
  branches: 'positionsSettingsBranches',
  compliance: 'positionsSettingsCompliance'
};

export const POSITIONS_SETTINGS_ALL_BRANCHES = 'allBranches';

export const POSITIONS_SETTINGS_COMPLIANCE = {
  WITH: 'withCompliance',
  WITHOUT: 'withoutCompliance'
};

export const NON_BOOKED_BOOKING_STATUS = 1;
export const PARTIALLY_BOOKED_BOOKING_STATUS = 2;
export const FULLY_BOOKED_BOOKING_STATUS = 3;

export const BOOKING_STATUS_MAPPING = {
  [NON_BOOKED_BOOKING_STATUS]: 'nonBooked',
  [PARTIALLY_BOOKED_BOOKING_STATUS]: 'partiallyBooked',
  [FULLY_BOOKED_BOOKING_STATUS]: 'fullyBooked'
};

export const WARNING_BOOKING_ISSUE = 'error';
export const NOTICEABLE_BOOKING_ISSUE = 'warning';
export const OK_BOOKING_ISSUE = 'ok';

export const BOOKING_ISSUES_MAPPING = {
  [WARNING_BOOKING_ISSUE]: 'warnings',
  [NOTICEABLE_BOOKING_ISSUE]: 'noticeable',
  [OK_BOOKING_ISSUE]: 'ok'
};

export const OVER_77_WARNING = 'shiftsWithAgeWarnings77';
export const UNDER_18_WARNING = 'shiftsWithAgeWarningsUnder18';

export const GENERAL_FILTERS_SLUGS = {
  BRANCHES: 'branches',
  POSITIONS: 'positions',
  LOCATIONS: 'locations',
  CLIENTS: 'clients',
  AGENCIES: 'agencies',
  COST_CENTER: 'costCenter',
  START_TIMES: 'startTimes',
  END_TIMES: 'endTimes',
  EVENT_BOOKER: 'eventBooker',
  APPROVED: 'approved',
  CLIENT_APPROVAL: 'clientApproval',
  TAGS: 'tags',
  SHIFT_TYPES: 'shiftTypes',
  WITH_CLOCK_IN: 'withClockIn',
  WITH_CLOCK_OUT: 'withClockOut',
  WITH_CHECK_IN: 'withCheckIn',
  WITH_CHECK_OUT: 'withCheckout',
  WITH_BREAKS: 'withBreaks',
  ACCOUNT_ROLE: 'adminRole',
  CONTRACT: 'employeeContract',
  LEAVE_CONTRACT: 'employeeLeaveContract',
  CLOCK_SOURCE: 'clockSource'
};

export const FORECASTING_FILTERS_EVENTS_SLUGS = [
  GENERAL_FILTERS_SLUGS.CLIENTS,
  GENERAL_FILTERS_SLUGS.TAGS,
  GENERAL_FILTERS_SLUGS.EVENT_BOOKER,
  GENERAL_FILTERS_SLUGS.POSITIONS
];

export const TIMESHEET_TAB_FILTERS_SLUGS = [
  GENERAL_FILTERS_SLUGS.POSITIONS,
  GENERAL_FILTERS_SLUGS.LOCATIONS
  // GENERAL_FILTERS_SLUGS.START_TIMES,
  // GENERAL_FILTERS_SLUGS.END_TIMES,
];

export const TIMESHEET_FILTERS_SLUGS = [
  ...TIMESHEET_TAB_FILTERS_SLUGS,
  GENERAL_FILTERS_SLUGS.CLIENTS,
  GENERAL_FILTERS_SLUGS.TAGS,
  GENERAL_FILTERS_SLUGS.EVENT_BOOKER
];
export const PAYROLL_FILTERS_EVENTS_SLUGS = [
  GENERAL_FILTERS_SLUGS.LOCATIONS,
  GENERAL_FILTERS_SLUGS.CLIENTS,
  GENERAL_FILTERS_SLUGS.TAGS,
  GENERAL_FILTERS_SLUGS.EVENT_BOOKER
];

export const PAY_RATES_FILTERS_EVENTS_SLUGS = [GENERAL_FILTERS_SLUGS.CLIENTS];

export const PAYROLL_PROCESS_STATUS = {
  PROCESSED: 'processed',
  PAY_QUERY: 'payQuery',
  OTHER: 'other'
};

// like from backend
export const INVOICE_STATUS = {
  PENDING: 0,
  ISSUED: 1
};
